import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { Cont } from './styled'

const DummyInput = (props) => {

  return (
    <Cont>
      <span>
        {props.label||'   '}
      </span>
      <div>
        {props.value}
      </div>
    </Cont>
  )
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = {
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps)
)

export default enhance(DummyInput)